$(function() {

    // style

    $('.js-menu-bars').on('click', function() {

        $(this).toggleClass('hover');
        $('html, body').toggleClass('open-menu');

    });

    if($(document).width() >= 1024){

        $('.js-menu-bars').on('mouseenter', function() {

            $(this).addClass('hover');
            $('html, body').addClass('open-menu');

        });

        $('.js-menu-bars').on('mouseleave', function() {

            $(this).removeClass('hover');
            $('html, body').removeClass('open-menu');

        });
        

        $('.js-menu-bars li > a').on('mouseenter', function() {

            let _y = $(this).position().top;
            let _bars = $('.js-menu-bars').find('.desktop-menu-bars');

            _bars.css('top', _y + 'px');


        });

        $('.js-menu-bars li > a').on('mouseleave', function() {
            
            let _bars = $('.js-menu-bars').find('.desktop-menu-bars');
            _bars.css('top', 0);

        });

    }

    // dinàmica de capes:

    let _layer_count = 0;
    
    $('.js-main-menu > li').attr('data-index', -1);

    $('.js-main-menu > li > a').on('click', function(e, fromHistory){
		
        e.stopImmediatePropagation();

        let _li = $(this).parent();
        
        var _index = parseInt(_li.attr('data-index'));

        if( _index >= 0){

            // si la capa ja està activa, amaguem les de sobre.

            const _li_with_higher_index = _li.siblings().filter(function() {

                return parseInt($(this).attr('data-index'), 10) > _index;

            });

            for (let i = 0; i < _li_with_higher_index.length; i++) {
                hide_layer();
            }
            
        }else{

            // si la capa no està activa, la mostrem

            let _index = _li.index();

            _li.attr('data-index', _layer_count); 

            show_layer(_index);

        }

        if($(document).width() < 1024){

            $('.js-menu-bars').removeClass('hover');
            $('html, body').removeClass('open-menu');

        }

        if (!fromHistory) {

            history.pushState({}, '', this.href);

        }

        return false;
        
	});

    // si cliquem sobre una capa, amaguem les de sobre
    $('.js-overlays-list > li').on('click', function(evt){

        if ($(evt.target).hasClass('js-prevent-hide-layer')
            || $(evt.target).hasClass('js-hide-layer')) {

            return false;

        }
		
        // index de capa posat al final de la classe js-position-
        const currentIndex = parseInt( $(this).attr('class').match(/js-position-(\d+)/)[1] );

        // siblings amb index més alts
        const _li_with_higher_index = $(this).siblings().filter(function() {

            const match = $(this).attr('class').match(/js-position-(\d+)/);

            return match && parseInt(match[1]) > currentIndex;

        });

        for (let i = 0; i < _li_with_higher_index.length; i++) {
            hide_layer();
        }
        
	});

    
    function show_layer(_what_layer){

        _layer_count++;

        let _layer_to_show = $('.js-overlays-list').find('> li').eq(_what_layer);
            _layer_to_show.removeClass(function(index, className) { return (className.match(/(^|\s)js-position-\S+/g) || []).join(' '); });
            _layer_to_show.removeClass(function(index, className) { return (className.match(/(^|\s)js-size-\S+/g) || []).join(' '); });
            _layer_to_show.addClass('js-position-' + _layer_count);
            _layer_to_show.addClass('js-size-' + _layer_count);
            _layer_to_show.addClass('active');

        if(!$('body').hasClass('open-layer')){
            $('body').addClass('open-layer');
        }
        if(_layer_to_show.hasClass('template-contact')){ 
            $('body').addClass('open-contact-layer'); 
        }


    }

   

    function hide_layer(){

        let _layer_to_hide = $('.js-overlays-list').find('li.js-position-' + _layer_count);

        _layer_to_hide.removeClass(function(index, className) {

            return (className.match(/(^|\s)js-position-\S+/g) || []).join(' ');

        });
 
        $('body').addClass('layers-are-hiding');

        setTimeout(function(){

            $('body').removeClass('layers-are-hiding');

            _layer_to_hide.removeClass('active');
            _layer_to_hide.removeClass(function(index, className) {

                return (className.match(/(^|\s)js-size-\S+/g) || []).join(' ');

            });

            if(_layer_to_hide.find('.js-projects-block').length > 0){
                $(document).trigger('go_back_to_projects');    
            }

        }, 500);

         _layer_count--;

        // desacoblem l'element del menú principal que correspon a la capa que amaguem
        var _elm = $('.js-main-menu > li[data-index="' + _layer_count + '"]');
            _elm.attr('data-index', -1);
         
        if(_layer_count == 0) $('body').removeClass('open-layer open-contact-layer');

      //  history.back(); // si es sofistica la lògica, possible bug de loop aturable via flag global _fromhistory

    }
        
    function hide_all_layers(){
        
        $('[class*="js-position-"]').removeClass(function(index, className) {

            return (className.match(/(^|\s)js-position-\S+/g) || []).join(' ');

        });

        $('body').addClass('layers-are-hiding');
         setTimeout(function(){
            $('body').removeClass('layers-are-hiding');
            $('.js-overlays-list').find('li').removeClass(function(index, className) {

                return (className.match(/(^|\s)js-size-\S+/g) || []).join(' ');

            });
            $('.js-overlays-list').find('li').removeClass('active');
            $(document).trigger('go_back_to_projects');    
            
        }, 500);

        _layer_count = 0;

        $('.js-main-menu > li').attr('data-index', -1)
        
        $('body').removeClass('open-layer open-contact-layer');

        history.pushState({}, '', '/'); // si es sofistica la lògica, possible bug de loop aturable via flag global _fromhistory

    }

    $('.js_hide_all_layers').on('click', function(){
        hide_all_layers();
    });


    $('.js-open-context-overlay').on('click', function(){
        
        _layer = $('.js-overlays-list > li.template-context');
        
        if(_layer.length > 0){

            _index = _layer.index();
            show_layer(_index);

        }

        return false;

    });

    $('.js-hide-layer').on('click', function(){
        
        hide_layer();

    });


    // Càrrega inicial
    openCurrentMenuItem(false);

});


// url history

$(window).on('popstate', function() {

    openCurrentMenuItem(true);

});

function openCurrentMenuItem(fromHistory = false) {

    const currentPath = window.location.pathname;

    $('.js-main-menu a').each(function() {

        if (new URL(this.href).pathname === currentPath) {

            $(this).trigger('click', [fromHistory]);

            return false;

        }

    });

}
